export const mediaTypes = {
  jpg: 'image',
  png: 'image',
  gif: 'image',
  mp4: 'video',
  mov: 'video',
};
